import React, { useEffect, useState } from 'react';

import { Check } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import CustomSnackbar from '../../uiParts/CustomSnackbar';
import Header from '../../uiParts/Header';
import { gray100, primaryButtonOutlinedColor } from '../../../constants/Colors';
import { headerHeight, spHeaderHeight } from '../../../constants/Location';
import { browserBack } from '../../../modules/error';
import CustomHead from '../CustomHead';

const styles = {
  checkIcon: {
    '@media screen and (max-width:600px)': {
      fontSize: '64px'
    },
    fontSize: '80px',
    width: '100%'
  },
  container: {
    '@media screen and (max-width:600px)': {
      height: `calc( 100vh - ${spHeaderHeight} - 64px)`,
      m: `${spHeaderHeight} auto 0`,
      pt: '64px',
      width: '90%'
    },
    height: `calc( 100vh - ${headerHeight} - 96px )`,
    m: `${headerHeight} auto 0`,
    pt: '96px',
    width: '560px'
  },
  text: {
    color: gray100,
    mt: '24px',
    textAlign: 'center'
  },
  primaryButtonOutlinedColor,
  title: {
    color: gray100,
    fontSize: '24px',
    fontWeight: '500',
    mt: '16px',
    textAlign: 'center'
  }
};

const MemberRegisterComplete: React.FC = () => {
  const navigate = useNavigate();
  const [errorText, setErrorText] = useState('');
  const [finishStatus, setfinishStatus] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const browserBackAlert = (e: { preventDefault: () => void }): void => {
    if (!finishStatus) {
      e.preventDefault();
      setOpen(true);
      setErrorText(browserBack);
      window.history.pushState(null, '', window.location.pathname);
      setfinishStatus(false);
    }
  };

  useEffect(() => {
    history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', browserBackAlert);
    return () => {
      window.removeEventListener('popstate', browserBackAlert);
    };
  }, []);

  return (
    <>
      <CustomHead title="会員登録完了 | CMCOS[コムコス]" />
      <Header />
      <Typography component="div" sx={styles.container}>
        <Check sx={styles.checkIcon} />
        <Typography sx={styles.title}>登録が完了しました</Typography>
        <Typography sx={styles.text}>
          CMCOSへようこそ！
          <br />
          低CO2建材を探してみましょう。
        </Typography>
        <Button
          fullWidth
          onClick={() => {
            navigate('/home');
          }}
          sx={[styles.primaryButtonOutlinedColor, { mt: '80px' }]}
          variant="outlined"
        >
          ホームへ
        </Button>
        <CustomSnackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          text={errorText}
        />
      </Typography>
    </>
  );
};

export default MemberRegisterComplete;
